import { render, staticRenderFns } from "./auth_nlg.vue?vue&type=template&id=5aaf9048&scoped=true&"
import script from "./auth_nlg.vue?vue&type=script&lang=js&"
export * from "./auth_nlg.vue?vue&type=script&lang=js&"
import style0 from "./auth_nlg.vue?vue&type=style&index=0&id=5aaf9048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf9048",
  null
  
)

export default component.exports